import { FhsAxios } from "../../services/axios";
import moment from "moment";

export default {
  state: {
    debitList: null,
    toDebitDate: moment()
      .subtract(1, "days")
      .format("DD.MM.YYYY")
  },
  actions: {
    fetchUserDebit({ commit, getters }) {
      commit("unsetUserDebit");

      let url = "user/debits";
      if (
        getters.selectedPortfolio !== "all" &&
        getters.selectedPortfolio !== undefined
      ) {
        url += "/" + getters.selectedPortfolio;
      }
      FhsAxios.post(url, {
        toDate: getters.toDebitDate
      }).then(response => {
        commit("setUserDebit", response.data.result.debits);
      });
    },
    changeToDebitDate({ commit, dispatch }, toDebitDate) {
      // Показываем прелоадер
      commit("unsetUserDebit");
      // Выставляем новый промежуток даты
      commit("setToDebitDate", toDebitDate);
      // Загружаем новые данные
      dispatch("fetchUserDebit");
    }
  },
  mutations: {
    setUserDebit(state, debitList) {
      state.debitList = debitList;
    },
    setToDebitDate(state, toDebitDate) {
      state.toDebitDate = toDebitDate;
    },
    unsetUserDebit(state) {
      state.debitList = null;
    }
  },
  getters: {
    userDebit(state) {
      return state.debitList;
    },
    toDebitDate(state) {
      return state.toDebitDate;
    }
  }
};
